import axios from "axios";

export const AxiosInstance = axios.create({
  baseURL: document.kvConfig.domain || "",
  // timeout: 120000,
  headers: {
    "Content-Type": "application/json",
  }
});

// AxiosInstance.interceptors.response.use((response) => {
//   const {serverState} = store.getState();
//   if (!serverState.networkConnection) {
//     store.dispatch(setNetworkConnection(true))
//   }
//   return response;
// }, (error) => {
//   // Do something with response error
//   if (error && error.toJSON && error.toJSON().message === "Network Error") {
//     store.dispatch(setNetworkConnection(false))
//   }
//   return Promise.reject(error);
// });

export const leadApiGet = (url) => {
  return AxiosInstance.get(url)
};

export const leadApiPost = (url, data, headers = null) => {
  return AxiosInstance.post(url, data, headers ? {headers} : null);
}
